import React from 'react';
import AuHeading from '../AuHeading/AuHeading';

import './AuCallout.scss';

interface IAuCallout {
  title?: string;
  className?: string;
  srOnlyTitle?: boolean;
  dark?: boolean;
  alt?: boolean;
  style?: React.CSSProperties;
}

/**
 * Default callout
 */
const AuCallout: React.FC<IAuCallout> = ({ title, dark, alt, children, srOnlyTitle = false, className = '', ...attributeOptions }) => (
  <section
    className={
      `au-callout ${className}` +
      `${dark ? ' au-callout--dark' : ''}` +
      `${alt ? ' au-callout--alt' : ''}`}
    {...attributeOptions}
  >
    {
      title &&
      <AuHeading level='2' className={`au-callout__heading ${srOnlyTitle ? 'au-callout__heading--sronly' : ''}`}>
        {title}
      </AuHeading>
    }
    {children}
  </section>
);

export default AuCallout;